// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/workspace/mars-web/node_modules/.pnpm/@umijs+runtime@3.5.43_react@17.0.2/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/layouts/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/workspace/mars-web/apps/base-app/src/layouts/BlankLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__LoginLayout__index' */'/workspace/mars-web/apps/base-app/src/layouts/LoginLayout/index'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "login",
            "path": "/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Login__login' */'/workspace/mars-web/apps/base-app/src/pages/Login/login'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "verifyCodeLogin",
            "path": "/login/verifyCodeLogin",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Login__verifyCodeLogin' */'/workspace/mars-web/apps/base-app/src/pages/Login/verifyCodeLogin'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "register",
            "path": "/login/register",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Login__register' */'/workspace/mars-web/apps/base-app/src/pages/Login/register'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "resetPassword",
            "path": "/login/resetPassword",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Login__resetPassword' */'/workspace/mars-web/apps/base-app/src/pages/Login/resetPassword'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/mpAuth",
        "name": "mpAuth",
        "icon": "smile",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__auth__index' */'/workspace/mars-web/apps/base-app/src/pages/main-base/auth/index'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/merchant",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__AccountLayout' */'/workspace/mars-web/apps/base-app/src/layouts/AccountLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "merchantShopList",
            "path": "/merchant/shopList",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Merchant__shopList__shopList' */'/workspace/mars-web/apps/base-app/src/pages/Merchant/shopList/shopList'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "merchantShopList",
            "path": "/merchant/shopList/create",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Merchant__shopList__create' */'/workspace/mars-web/apps/base-app/src/pages/Merchant/shopList/create'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "chooseStoreList",
            "path": "/merchant/chooseStore",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Merchant__shopList__chooseStoreList' */'/workspace/mars-web/apps/base-app/src/pages/Merchant/shopList/chooseStoreList'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "payShopOrder",
            "path": "/merchant/pay",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Merchant__shopPay' */'/workspace/mars-web/apps/base-app/src/pages/Merchant/shopPay'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout__index' */'/workspace/mars-web/apps/base-app/src/layouts/BasicLayout/index'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "home",
            "category": "OPERATION_CENTER",
            "path": "/home",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home' */'/workspace/mars-web/apps/base-app/src/pages/Home'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_MAIN_DATA_OVERVIEW",
              "PERMISSION_MAIN_TO_DO",
              "PERMISSION_MAIN_PRODUCT_TOP"
            ],
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product/saleSchannel",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync__operation-detail__sale-schannel' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync/operation-detail/sale-schannel'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product/productInventory",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync__operation-detail__product-inventory' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync/operation-detail/product-inventory'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product/readOmsProductSyncDetail",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync__record-sync__read-oms-product-sync-detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync/record-sync/read-oms-product-sync-detail'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product/readLocationProductSyncDetail",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync__record-sync__read-location-product-sync-detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync/record-sync/read-location-product-sync-detail'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product/readLocationSyncDetail",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync__record-sync__read-location-sync-detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync/record-sync/read-location-sync-detail'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-takeout-product",
            "path": "/main-operations/oms/takeout/product/rule",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__third-product-sync__operation-detail__third-rule' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/third-product-sync/operation-detail/third-rule'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_TAKEOUT_DISH_ISSUE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-mtproduct",
            "path": "/main-operations/oms/mt/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__mt__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/mt/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_MT_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-mtlocation",
            "path": "/main-operations/oms/mt/manager",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__mt__manager' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/mt/manager'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_MT_AUTHROIZE_MANAGE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-ebproduct",
            "path": "/main-operations/oms/ebls/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__ebls__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/ebls/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_EB_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-eblocation",
            "path": "/main-operations/oms/ebls/settings",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__ebls__productSettings' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/ebls/productSettings'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_EB_LOCATION_SET"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-ebmanager",
            "path": "/main-operations/oms/ebls/manager",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__ebls__authManager' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/ebls/authManager'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_EB_AUTHROIZE_MANAGE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-elmproduct",
            "path": "/main-operations/oms/elm/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__elm__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/elm/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_EL_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-elmlocation",
            "path": "/main-operations/oms/elm/settings",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__elm__productSettings' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/elm/productSettings'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_EL_LOCATION_SET"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-elmmanager",
            "path": "/main-operations/oms/elm/manager",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__elm__authManager' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/elm/authManager'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_EL_AUTHROIZE_MANAGE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-tiktokproduct",
            "path": "/main-operations/oms/dy/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__dy__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/dy/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_TIKTOK_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-tiktoklocation",
            "path": "/main-operations/oms/dy/location",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__dy__location' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/dy/location'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_TIKTOK_LOCATION_SET"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-tiktokmanager",
            "path": "/main-operations/oms/dy/manager",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__dy__authManager' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/dy/authManager'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_TIKTOK_AUTHROIZE_MANAGE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-tiktokselfproduct",
            "path": "/main-operations/oms/tiktokSelf/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__tiktokSelf__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/tiktokSelf/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-tiktokselflocation",
            "path": "/main-operations/oms/tiktokSelf/location",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__tiktokSelf__location' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/tiktokSelf/location'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_SET"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-tiktokselfmanager",
            "path": "/main-operations/oms/tiktokSelf/manager",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__tiktokSelf__authManager' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/tiktokSelf/authManager'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_TIKTOK_SELF_CHECK_AUTHROIZE_MANAGE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-jdmanager",
            "path": "/main-operations/oms/jd/manager",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__jd__authManager' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/jd/authManager'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_JD_AUTHROIZE_MANAGE"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-jdproduct",
            "path": "/main-operations/oms/jd/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__jd__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/jd/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_JD_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-jdlocation",
            "path": "/main-operations/oms/jd/settings",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__jd__productSettings' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/jd/productSettings'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_JD_LOCATION_SET"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-mtsgproduct",
            "path": "/main-operations/oms/mtsg/product",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__mtsg__product' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/mtsg/product'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_MTSG_LOCATION_PRODUCT"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-mtsglocation",
            "path": "/main-operations/oms/mtsg/settings",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__oms__mtsg__productSettings' */'/workspace/mars-web/apps/base-app/src/pages/main-base/oms/mtsg/productSettings'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_OMS_MTSG_LOCATION_SET"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-notifySettings",
            "path": "/main-operations/notifySettings",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__notify-settings' */'/workspace/mars-web/apps/base-app/src/pages/main-base/notify-settings'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_SETTING_NOTIFY"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsGroupSend",
            "path": "/main-operations/marketingActivities/smsGroupSend",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms-group-send__list' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms-group-send/list'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_PROMOTION_SMS_GROUP_SEND"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsGroupSend",
            "path": "/main-operations/marketingActivities/smsGroupSend/detail",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms-group-send__modify' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms-group-send/modify'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_PROMOTION_SMS_GROUP_SEND"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsGroupSend",
            "path": "/main-operations/marketingActivities/smsGroupSend/read",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms-group-send__modify' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms-group-send/modify'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_PROMOTION_SMS_GROUP_SEND"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsGroupSend",
            "path": "/main-operations/marketingActivities/smsGroupSend/copy",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms-group-send__modify' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms-group-send/modify'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_PROMOTION_SMS_GROUP_SEND"
            ],
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsTemplate",
            "path": "/main-operations/sms/setting/smsTemplate",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms__smsTemplate__list' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms/smsTemplate/list'), loading: LoadingComponent}),
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsTemplate",
            "path": "/main-operations/sms/setting/smsTemplate/new",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms__smsTemplate__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms/smsTemplate/detail'), loading: LoadingComponent}),
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-smsTemplate",
            "path": "/main-operations/sms/setting/smsTemplate/read",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms__smsTemplate__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms/smsTemplate/detail'), loading: LoadingComponent}),
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-operations-templateType",
            "path": "/main-operations/sms/setting/smsType",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__sms__smsType__list' */'/workspace/mars-web/apps/base-app/src/pages/main-base/sms/smsType/list'), loading: LoadingComponent}),
            "category": "OPERATION_CENTER",
            "exact": true
          },
          {
            "name": "main-serviceMarket",
            "path": "/main-serviceMarket",
            "routes": [
              {
                "name": "main-serviceMarket-equityAccountList",
                "path": "/main-serviceMarket/equityAccountList",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__equityAccountList' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/equityAccountList'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-lezhiMyPurchase",
                "path": "/main-serviceMarket/settings/lezhiMyPurchase",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lezhiMyPurchase' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lezhiMyPurchase'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_MY_PURCHASE"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-MTOrderApiCall",
                "path": "/main-serviceMarket/settings/valueAdd/MTOrderApiCall/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__mtTakeout' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/mtTakeout'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-MTOrderApiCall",
                "path": "/main-serviceMarket/settings/valueAdd/buyMTOrder/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyMTOrder' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyMTOrder'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-MTOrderApiCall",
                "path": "/main-serviceMarket/settings/valueAdd/buyMTOrderDetail/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyMTOrderDetail' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyMTOrderDetail'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-platformOrderSync",
                "path": "/main-serviceMarket/settings/valueAdd/buyOrderSync/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyOrderSync' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyOrderSync'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-platformOrderSync",
                "path": "/main-serviceMarket/settings/valueAdd/platformOrderSync/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__platformOrderSync' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/platformOrderSync'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-storeAccountSettings",
                "path": "/main-serviceMarket/storeAccountSettings",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__storeAccountSettings' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/storeAccountSettings'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_LOCATION_ACCOUNT_SETTING"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-expenseOrder",
                "path": "/main-serviceMarket/expense/order",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__expense__order' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/expense/order'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_FINANCE"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-expenseOrder",
                "path": "/main-serviceMarket/expense/order/detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__expense__order__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/expense/order/detail'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_FINANCE"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-lemonServices",
                "path": "/main-serviceMarket/settings/lemonServices",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lemonServices' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lemonServices'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_MARKET"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-temporaryPosPoint",
                "path": "/main-serviceMarket/settings/lemonServices/temporaryPosPoint",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lemonServices__temporaryPosPoint' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lemonServices/temporaryPosPoint'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_TEMP_POS_LIMIT"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-lemonServices",
                "path": "/main-serviceMarket/settings/lemonServices/locationRenewals",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lemonServices__locationRenewals' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lemonServices/locationRenewals'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_MARKET"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-lemonServices",
                "path": "/main-serviceMarket/settings/lemonServices/invoiceDetails",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lemonServices__invoiceDetails' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lemonServices/invoiceDetails'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_MARKET"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-lemonServices",
                "path": "/main-serviceMarket/settings/lemonServices/lemonServicesWecomBuy",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lemonServices__lemonServicesWecomBuy' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lemonServices/lemonServicesWecomBuy'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_MARKET"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-lemonServices",
                "path": "/main-serviceMarket/settings/lemonServices/authorization",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__lemonServices__weCome__authorization' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/lemonServices/weCome/authorization'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SERVICE_MARKET"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-invoice",
                "path": "/main-serviceMarket/expense/invoice",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__expense__invoice' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/expense/invoice'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_INVOICE_MANAGEMENT"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-invoiceDetail",
                "path": "/main-serviceMarket/expense/invoice/detail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__expense__invoice__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/expense/invoice/detail'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_INVOICE_MANAGEMENT"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-MTOrderApiCall",
                "path": "/main-serviceMarket/settings/valueAdd/platformProgramCall",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__platformProgramCall' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/platformProgramCall'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_PLATFORM_APPLET_CALL"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-MTOrderApiCall",
                "path": "/main-serviceMarket/settings/valueAdd/buyPlatformDetail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyPlatformDetail' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyPlatformDetail'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_PLATFORM_APPLET_CALL"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-MTOrderApiCall",
                "path": "/main-serviceMarket/settings/valueAdd/buyPlatform",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyPlatform' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyPlatform'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_PLATFORM_APPLET_CALL"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/messageDetail/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__messageDetail' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/messageDetail'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/messageDetail",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__messageDetail' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/messageDetail'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/new/messageList/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__messageList' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/messageList'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/new/messageList",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__messageList' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/messageList'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/messageStat/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__messageStat' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/messageStat'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/messageStat",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__messageStat' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/messageStat'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/buyMessage/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyMessage' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyMessage'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              },
              {
                "name": "main-serviceMarket-messageDetail",
                "path": "/main-serviceMarket/settings/valueAdd/buyMessage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-serviceMarket__settings__valueAdd__buyMessage' */'/workspace/mars-web/apps/base-app/src/pages/main-serviceMarket/settings/valueAdd/buyMessage'), loading: LoadingComponent}),
                "code_key": [
                  "PERMISSION_SETTING_VALIE_ADD"
                ],
                "category": "SERVICE_MARKET",
                "exact": true
              }
            ]
          },
          {
            "name": "main-account",
            "path": "/main-account",
            "routes": [
              {
                "name": "main-account-userInfo",
                "path": "/main-account/account",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-account__userInfo' */'/workspace/mars-web/apps/base-app/src/pages/main-account/userInfo'), loading: LoadingComponent}),
                "category": "ACCOUNT",
                "exact": true
              },
              {
                "name": "main-account-security",
                "path": "/main-account/security",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-account__security' */'/workspace/mars-web/apps/base-app/src/pages/main-account/security'), loading: LoadingComponent}),
                "category": "ACCOUNT",
                "exact": true
              }
            ]
          },
          {
            "name": "main-base-invoice-management",
            "path": "/main-base/invoice-management",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-management' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-management'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_BODY"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-base-invoice-management",
            "path": "/main-base/invoice-management/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-management__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-management/detail'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_BODY"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-base-invoice-management",
            "path": "/main-base/invoice-management/qixiang/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-management__qixiang-cloud-detail' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-management/qixiang-cloud-detail'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_BODY"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-base-invoice-locations",
            "path": "/main-base/invoice-locations",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-locations' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-locations'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_LOCATION_SETTING"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-base-invoice-setup",
            "path": "/main-base/invoice-setup",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-setup' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-setup'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_SETTING"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-base-invoice-apply",
            "path": "/main-base/invoice-apply",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-apply' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-apply'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_APPLY"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-base-invoice-record",
            "path": "/main-base/invoice-record",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-base__invoice-record' */'/workspace/mars-web/apps/base-app/src/pages/main-base/invoice-record'), loading: LoadingComponent}),
            "code_key": [
              "PERMISSION_INVOICE_RECORD"
            ],
            "category": "FINANCE_CENTER",
            "exact": true
          },
          {
            "name": "main-message",
            "path": "/main-message/message-list",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-message__list' */'/workspace/mars-web/apps/base-app/src/pages/main-message/list'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "main-message",
            "path": "/main-message/message-list/new",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-message__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-message/detail'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "main-message",
            "path": "/main-message/message-list/:id?",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__main-message__detail' */'/workspace/mars-web/apps/base-app/src/pages/main-message/detail'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/download/customDownload",
            "name": "customDownload",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__download' */'/workspace/mars-web/apps/base-app/src/pages/download'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/refuse",
            "name": "refuse",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Refuse' */'/workspace/mars-web/apps/base-app/src/pages/Refuse'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "403",
        "path": "/403",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__403' */'/workspace/mars-web/apps/base-app/src/pages/403'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "404",
        "path": "/404",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/workspace/mars-web/apps/base-app/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "redirect": "/404",
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/workspace/mars-web/apps/base-app/src/pages/404'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
